import { createAction } from '@reduxjs/toolkit';
import { Stream } from '../../../../Models/Stream/Stream';
import { TwitchToken } from '../../../../Utils/Types';

const setTwitchToken = createAction<TwitchToken>('SET_TWITCH_TOKEN');
const setStream = createAction<Stream>('SET_STREAM');

export default {
  setTwitchToken,
  setStream
};
